const prefix = 'group-details-common-info';

const SET_GROUP_NAME = `${prefix}/SET_GROUP_NAME`;

// eslint-disable-next-line import/prefer-default-export
export { SET_GROUP_NAME };
